import { defineComponent as _defineComponent } from 'vue'
import LoadingGif from "./loading/LoadingGif.vue";
import TableauButton from "./TableauButton.vue";
import TableauLink from "./TableauLink.vue";
import { onMounted, ref } from "vue";
import { CommonModule } from "../modules/common.module";
import { container } from "tsyringe";

export default /*#__PURE__*/_defineComponent({
  __name: 'TableauPopup',
  props: {
    title: { type: String, required: true },
    submitText: { type: String, required: true },
    width: { type: Number, required: true },
    canSubmit: { type: Boolean, required: true },
    status: { type: String, required: false, default: "idle" },
    statusMessage: { type: String, required: false },
    statusLink: { type: Object, required: false }
  },
  emits: ["submitted"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;



const popupRoot = ref<Element | null>(null);
const floater = ref<HTMLElement | null>(null);
function close() {
  if (popupRoot.value) {
    popupRoot.value.parentElement?.remove();
  }
}
onMounted(async () => {
  await container.resolve(CommonModule).requestAnimationFrame();
  if (floater.value) {
    floater.value.style.top = `max(50px, calc(30vh - ${Math.round(
      floater.value.offsetHeight / 2
    )}px))`;
    floater.value.style.left = `calc(50vw - ${Math.round(
      floater.value.offsetWidth / 2
    )}px)`;
  }
});
__expose({
  close,
});

const __returned__ = { props, emits, popupRoot, floater, close, TableauButton, TableauLink }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})